<template>
    <div class="head-record" @click="clickEvent">
        <el-tooltip class="item" effect="dark" content="知识库" placement="bottom">
            <img class="iconfont" src="@/assets/img/knowledge.png" />
        </el-tooltip>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {
        clickEvent() {
            window.open('http://wcp.utopacloud.com');
        }
    }
};
</script>

<style lang="less" scoped>
.head-record {
    cursor: pointer;

    .iconfont {
        color: #fff;
        margin-right: 33px;
        vertical-align: middle;
    }
}
</style>
